<template>
  <div id="List">
    <vue-data-loading :loading="loading" :completed="completed" :listens="['infinite-scroll']" :init-scroll="true" @infinite-scroll="infiniteScroll">
      <div class="content border-bottom" v-for="item in alist" :key="item.id">
        <div class="order-message">
          <div>
            <img :src="item.imgUrl ? url + item.imgUrl : defaultimg">
          </div>
          <div>
            <p>{{item.company}}</p>
            <p class="spec">{{item.level}}</p>
            <p class="tel">{{item.tel}}</p>
          </div>
        </div>
        <div class="order-total">
          <p>{{item.introduce}}</p>
        </div>
      </div>
      <img class="empty" src="/static/img/mescroll-empty.png" v-show="show">
      <div slot="infinite-scroll-loading">loading...</div>
      <div slot="completed">没有更多供应商了~</div>
    </vue-data-loading>
  </div>
</template>

<script>
// 引入上拉加载组件
import VueDataLoading from 'vue-data-loading'
import url from '@/common/common.js'
export default {
  name: 'SupplierList',
  props: {
    list: Array
  },
  components: {
    VueDataLoading // 注册VueDataLoading组件
  },
  data () {
    return {
      loading: false,
      completed: false,
      num: 1,
      size: 10,
      alist: [],
      show: false,
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.getSuppInfo()
    },
    infiniteScroll () {
      this.fetchData()
      this.num++
    },
    getSuppInfo () {
      // 联网请求
      this.axios.get('/ApiSupplierList/GetList', {
        params: {
          num: this.num, // 页码
          size: this.size
        }
      }).then(this.getSuppInfoSucc)
        .catch(this.getSuppInfoFail)
    },
    getSuppInfoSucc (res) {
      res = res.data
      var newList = this.list
      if (res.ret && res.data) {
        const data = res.data
        // this.list.push(JSON.parse(data.supplierList))
        newList = JSON.parse(data.supplierList)
        if (newList.length === 0) {
          this.completed = true
          this.loading = false
          this.show = true
        } else {
          for (var i = 0; i < newList.length; i++) {
            setTimeout(() => {
              if (newList[i] <= 10) {
                this.completed = true
                this.loading = false
                return
              }
              const temp = []
              for (let i = newList.length + 1; i <= newList.length + 50; i++) {
                temp.push(i)
              }
              newList = newList.concat(temp)
              this.loading = false
            }, 1000)
            this.alist.push(newList[i])
            // console.log(this.alist)
          }
        }
      }
      // console.log(newList)
    },
    getSuppInfoFail (err) {
      alert(err)
    }
  }
}
</script>

<style scoped>
.vue-data-loading >>>.loading-header{ display: none!important;}
.empty{ display: block; margin: 0 auto; width: 100%;}
.content{ background-color: #fff; border-bottom: 10px solid #eff3f6; padding: 10px 15px;}
.order-message{ display: flex; font-size: 14px; background-color: #fafafa; padding: 5px;}
.order-message img{ margin-right: 11px; width: 60px; height: 60px;}
.tel{ color: #949494; font-size: 13px;}
.spec{ color: #ff6700; font-size: 13px;}
.order-total{ padding: 5px 0;}
.order-total p{ font-size: 12px; color: #a6a6a6;}
</style>



// WEBPACK FOOTER //
// src/pages/supplier_channel/components/List.vue